import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ErrorComponent, ApronErrorComponent } from '@up/web-order-receipt';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: 'view',
          loadChildren: () =>
            import('@up/web-order-receipt').then(
              (module) => module.WebOrderReceiptModule
            )
        },
        {
          path: 'apron-error',
          pathMatch: 'full',
          component: ApronErrorComponent,
          data: { breadcrumb: 'Error' }
        },
        {
          path: '**',
          pathMatch: 'full',
          redirectTo: 'error'
        },
        {
          path: 'error',
          pathMatch: 'full',
          component: ErrorComponent,
          data: { breadcrumb: 'Error' }
        }
      ],
      { initialNavigation: 'enabled', scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy' }
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
